
import './App.css';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Navbar from './components/Navbar/Navbar';
import Projects from './components/Projects/Projects';
import Services from './components/Services/Services';
// import Skills from './components/newSkills.js';
import {themeContext} from './Context'
import {useContext} from 'react'
import GithubStatus from './components/GithubStats/GithubStats';
// import NewSkills from './components/NewSkills';
import Skills from './components/Skills/Skills';

function App() {
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
  return (
    <div className="App"
    style={{background: darkMode ? 'black': '', color: darkMode ? 'white': ''}}
    >
      <div className='fixed-top' style={{background: darkMode ? 'black': 'white'}}>
      <Navbar/>
      </div>
      <Home/>
      <Services/>
      <Skills/>
      
      <Projects/>
      <GithubStatus />
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
